import { FormularioRepresentada as FormularioRepresentadaType } from './types';
import { FieldRowRepresentada, FieldRowNomeBotao, Label, Input, AddButton } from './styles';
import { Plus } from 'lucide-react';

const MAX_NOME = 200;

interface FormularioRepresentadaProps {
    formulario: FormularioRepresentadaType;
    podeAdicionar: boolean;
    isDisabled: boolean;
    onChange: (formulario: FormularioRepresentadaType) => void;
    onAdicionar: () => void;
}

export default function FormularioRepresentada({
    formulario,
    podeAdicionar,
    isDisabled,
    onChange,
    onAdicionar
}: FormularioRepresentadaProps) {
    const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        onChange({ nome: e.target.value });
    };

    return (
        <FieldRowRepresentada>
            <div>
                <Label>Nome da parte representada:</Label>
                <FieldRowNomeBotao>
                    <Input
                        value={formulario.nome}
                        placeholder="Digite o nome"
                        maxLength={MAX_NOME}
                        onChange={handleInputChange}
                        disabled={isDisabled}
                        style={{ flex: 1 }}
                    />
                    <AddButton
                        disabled={!podeAdicionar || isDisabled}
                        title={!podeAdicionar ? 'Preencha o nome da parte para adicioná-la' : ''}
                        onClick={onAdicionar}
                    >
                        <Plus size={14} />
                    </AddButton>
                </FieldRowNomeBotao>
            </div>
        </FieldRowRepresentada>
    );
}

